import { PinIcon } from 'de-suite-me-ui'

export default PinIcon
